import React from 'react'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'
import useStyles from './styles'

const TonalButton = ({ className, to, ...props }) => {
  const classes = useStyles()

  return (
    <Button
      variant="contained"
      component={to ? Link : undefined}
      to={to}
      className={
        className ? `${classes.tonalButton} ${className}` : classes.tonalButton
      }
      {...props}
    />
  )
}

export default TonalButton
